import { ArticleUrlType } from './model'

export const isTrustedHTML = (value: any): value is TrustedHTML =>
  'toString' in Object(value) && (value as TrustedHTML).toString !== undefined

export const isNotUndefined = <Type>(value: Type | undefined): value is Type =>
  value !== undefined

export const isNullOrUndefined = (value: unknown): value is null | undefined =>
  value === null || value === undefined

export const isPageAnArticle = (
  value: ArticleUrlType,
): value is ArticleUrlType.ARTICLE => value === ArticleUrlType.ARTICLE
